import * as Yup from 'yup';
import { PRIORITY_OPTIONS, STATUS_OPTIONS } from '../../../constants/statusConfig';
import { PORTFOLIO_STATUS_OPTIONS, PORTFOLIO_USAGE_OPTIONS } from '../../../constants/portfolioConfig';

// Extract values from options arrays for validation
const PRIORITY_VALUES = PRIORITY_OPTIONS.map(option => option.value);
const STATUS_VALUES = STATUS_OPTIONS.map(option => option.value);
const PORTFOLIO_STATUS_VALUES = PORTFOLIO_STATUS_OPTIONS.map(option => option.value);
const PORTFOLIO_USAGE_VALUES = PORTFOLIO_USAGE_OPTIONS.map(option => option.value);

// Validation schema for ActorUser
export const actorUserValidationSchema = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  actorType: Yup.string().required('Actor Type is required')
});

// Validation schema for Portfolio
export const portfolioValidationSchema = Yup.object({
  name: Yup.string()
    .required('Portfolio name is required')
    .test(
      'unique-name',
      'Portfolio name must be unique for this actor',
      function (value) {
        // This validation will be handled on the server side
        // The server will check if the name is unique for the actor
        return true;
      }
    ),
  description: Yup.string().required('Description is required'),
  usage: Yup.string().oneOf(PORTFOLIO_USAGE_VALUES, 'Invalid usage value').required('Usage is required'),
  status: Yup.string().oneOf(PORTFOLIO_STATUS_VALUES, 'Invalid status value').required('Status is required'),
  client: Yup.string() // Optional field for client
});

// Validation schema for Character
export const characterValidationSchema = Yup.object({
  name: Yup.string().required('Character name is required'),
  description: Yup.string().required('Description is required'),
  avatarUrl: Yup.string(), // Optional field for character avatar
  priority: Yup.string().oneOf(PRIORITY_VALUES, 'Invalid priority value'),
  status: Yup.string().oneOf(STATUS_VALUES, 'Invalid status value'),
  deadline: Yup.date().nullable()
});

// Validation schema for Variation
export const variationValidationSchema = Yup.object({
  name: Yup.string().required('Variation name is required'),
  s3Url: Yup.string(), // Optional field for Variation URL
  content: Yup.string(), // Optional field for content text
  version: Yup.number().required('Version is required').min(1, 'Version must be at least 1'),
  priority: Yup.string().oneOf(PRIORITY_VALUES, 'Invalid priority value'),
  status: Yup.string().oneOf(STATUS_VALUES, 'Invalid status value'),
  deadline: Yup.date().nullable()
});

// Validation schema for Opportunity
export const opportunityValidationSchema = Yup.object({
  title: Yup.string().required('Title is required'),
  description: Yup.string().required('Description is required'),
  bookId: Yup.string().required('Book is required'),
  characterId: Yup.string().required('Character is required'),
  compensation: Yup.string(),
  compensationType: Yup.string().required('Compensation type is required'),
  deadline: Yup.date().nullable(),
  requirements: Yup.array().of(Yup.string())
});

export default {
  actorUserValidationSchema,
  portfolioValidationSchema,
  characterValidationSchema,
  variationValidationSchema,
  opportunityValidationSchema
};
